import React, { useEffect } from "react";
import { useState } from "react";
import { getSiteRefrence } from "../../api/endpoints/refrences";
import { authSelector } from "../../store/selectors";
import { useSelector } from "react-redux";
import { message } from "antd";
// import "./style.css";

export const ComponentToPrint = React.forwardRef(({ item }, ref) => {
  const { access_token } = useSelector(authSelector);
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const [debitTotal, setDebitTotal] = useState();
  const [quantityTotal, setQuantityTotal] = useState();
  const [purchaseData, setPurchaseData] = useState([]);

  useEffect(() => {
    // Set the state of leftColumn and rightColumn
    setPurchaseData(item);
  }, [item]);

  const getName = async () => {
    const result = await getSiteRefrence(access_token);
    if (result.success) {
      console.log(result, "site");
      setSiteName(result.data.siteName);
      setSiteAddress(result.data.siteAddress);
    } else {
      message.error(result.message);
    }
  };

  useEffect(() => {
    getName();
  });



  return (
    <div ref={ref}>
      <div className=" flex flex-col items-center justify-center">
        <strong>
          {" "}
          <h1 style={{ fontSize: "25px" }}>{siteName}</h1>
        </strong>
        <strong>
          {" "}
          <h1 style={{ fontSize: "17px" }}>{siteAddress}</h1>
        </strong>

        <strong className="">
          <h1 style={{ fontSize: "17px" }}>Items List</h1>
        </strong>
      </div>
      <div class="relative mt-5 overflow-x-auto">
        <div className="flex justify-center">
          <div className=" w-11/12">
            <table class="w-full border-b-2 text-sm text-left text-black ">
              <thead class="text-black border-b-2 border-t-2 uppercase   ">
                <tr className="">
                  <th scope="col" class="w-auto  ">
                    {" "}
                    SNO{" "}
                  </th>
                  <th scope="col" class="w-auto ">
                    Item Code
                  </th>
                  <th scope="col" class="w-auto ">
                  Item Name
                  </th>
                  <th scope="col" class="w-auto ">
                    Sale Rate
                  </th>
                 
                </tr>
              </thead>

              {purchaseData.length > 0 &&
                purchaseData
                  // .slice()
                  // .sort((a, b) => new Date(a.enteredOn) - new Date(b.enteredOn))
                  .map((ele, i) => {
                    return (
                      <tbody key={i}>
                        {/* Make sure to add a unique key to each row */}
                        <tr className="bg-white dark:bg-gray-800 dark:border-gray-700">
                        <td className="">{i + 1}</td>
                        <td className="">{ele.itemCode}</td>
                          <td className="">{ele.itemName}</td>
                          <td className="">{ele.saleRate}</td>
                        </tr>
                      </tbody>
                    );
                  })}
            </table>
          </div>
        </div>
      </div>
    </div>
  );
});
